import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { ISpread } from '../interface/ISpread';

enum SpreadServiceEnum {
	base = '/',
	getById = '/',
	getByCourtAndNatureTypes = '/by-court-nature-types?'
}

export class SpreadService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/spread');
	}

	public getAll = async (): Promise<ISpread[]> => await this.GET(SpreadServiceEnum.base);
	public getById = async (id: number): Promise<ISpread> => await this.GET(SpreadServiceEnum.getById + id);
	public getByCourtAndNatureTypes = async (courtTypeId: number, natureTypeId: number): Promise<ISpread[]> =>
		await this.GET(SpreadServiceEnum.getByCourtAndNatureTypes + [`courtTypeId=${courtTypeId}&`, `natureTypeId=${natureTypeId}`]);
}
